module.exports = __webpack_public_path__ + "static/media/BOHM.9a4cebf2.png";